
import Confirm from 'vux/src/components/confirm/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


import "./index.less"
import util from '@/javascript/util'
import bus from '@/javascript/bus'
import mapUtil from '@/javascript/mapUtil'
import EsQuery from '@/javascript/esQuery'
import validate from '@/javascript/validate'
import Footer from "@/components/lyx-components/lyx-footer/index";
import Cpts030 from '@/components/public-components/cpts030/index.vue'
import goBack from '@/components/public-components/goBack/index.vue'

export default {
directives: {
TransferDom
},
components: {
Toast,
Confirm,
Footer,
Cpts030,
goBack
},
data () {
return {
address: '海北藏族自治州海晏县',
minHeight: 0,
maxTextLen: 500,
textLen: 500,
textValue: '',
maxFileLen: 9,
fileList: [],
popupShow: false,
placeholder: '',
searchVal: '',
tabCur: 0,
tabs: [
{
text: '景区',
code: this.XXCJ_TYPE_CODE.JQ
},
{
text: '住宿',
code: this.XXCJ_TYPE_CODE.JD
},

















],
businessList: [],
listPageNo: 0,
listPageSize: 10,
infiniteStatus: false,
infiniteAll: false,
selectedBusiness: {
id: '',
name: '',
phone: '',
bType: ''
},
cityList: [],
curCityIndex: 0,
curCountyIndex: -1,
address: '',
cityPopupShow: false,
toastShow: false,
toastText: '',
contactsName: '',
contactsPhone: '',
typeKind: 'saveFile',
show: !Boolean(bus.userInfo.access_token),
palceCode: '',
indexNameType: ''
}
},
mounted () {
document.title = '在线投诉'

this.minHeight = document.documentElement.clientHeight - this.$refs.footer.$el.offsetHeight


const myArea = document.getElementById("myArea")
if(myArea){
util.autoTextarea(myArea)
}


/**
* 底部加载
*/
const that = this
const el = document.getElementById('scroll_box')
el.onscroll = function () {
const scrollHeight = el.scrollHeight
const scrollTop = el.scrollTop
const clientHeight = el.clientHeight

if (scrollHeight - clientHeight == scrollTop) {
that.infinite()
}
}

/**
* 获取地区
*/
this.$http.get('/api/wtcp-coder/area/list?pcode=' + this.AREA_CODE.AREACODE.slice(0, 2)).then((response) => {
console.log(this.AREA_CODE.AREACODE)
response.data.data.map(item => {
if (this.AREA_CODE.AREACODE.indexOf(item.code) + 1) {
this.cityList.push(item)
}
})
}).then(() => {
this.cityList.forEach((item, index) => {
this.$http.get('/api/wtcp-coder/area/list?pcode=' + item.code).then((response) => {
this.$set(this.cityList[index], 'county', response.data.data)
})
})
})
},
watch: {
textValue (val) {
val = val.replace(/\ +/g, "").replace(/[ ]/g, "").replace(/[\r\n]/g, "")
if (val.length >= this.maxTextLen) {
this.textValue = val.substr(0, this.maxTextLen)
this.textLen = 0
} else {
this.textValue = val
this.textLen = this.maxTextLen - val.length
}
}
},
methods: {
showToast (text) {
this.toastText = text
this.toastShow = true
},
showPopup () {




this.searchVal = ''
this.tabCur = 0
this.businessList = []
this.listPageNo = 0
this.infiniteStatus = true
this.infiniteAll = false
this.placeholder = '搜索' + this.tabs[this.tabCur].text
this.getBusinessList()

this.popupShow = true
},
closePopup () {
this.popupShow = false
},
clearValue () {
this.searchVal = ''
},
searchFun () {
this.businessList = []
this.listPageNo = 0
this.infiniteStatus = true
this.infiniteAll = false
this.getBusinessList()
},
tabChange (index) {
this.tabCur = index
this.businessList = []
this.listPageNo = 0
this.infiniteStatus = true
this.infiniteAll = false
this.placeholder = '搜索' + this.tabs[index].text
this.getBusinessList()
},
getBusinessList () {
const businessEsQuery = new EsQuery()
if (this.tabs[this.tabCur].code == this.XXCJ_TYPE_CODE.JQ && this.tabCur === 0) {
this.indexNameType = this.INDEX_NAME_TYPE.scenic
businessEsQuery.addString("category", this.tabs[this.tabCur].code, businessEsQuery.and, false)
}
if (this.tabs[this.tabCur].code == this.XXCJ_TYPE_CODE.JD && this.tabCur === 1) {
this.indexNameType = this.INDEX_NAME_TYPE.hotelList
}
















const querystring = require('querystring')

if (this.searchVal) {
businessEsQuery.addKeyword("title", "*" + this.searchVal + "*", businessEsQuery.and, false)
}

businessEsQuery

.addString("deptCode", this.DEPT_CODE.DEPTCODE, businessEsQuery.and, false)
.addPage(this.listPageNo * this.listPageSize, this.listPageSize)
const businessEsJsonQuery = JSON.stringify(businessEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
'indexName': this.indexNameType,
'esJsonQuery': businessEsJsonQuery
})).then((response) => {
if (response.data.data) {
this.businessList = this.businessList.concat(response.data.data)
if (response.data.data.length < this.listPageSize) {
this.infiniteAll = true
}
this.infiniteStatus = false
}
})
},
infinite () {
if (this.infiniteAll || this.infiniteStatus) {
return
}
this.infiniteStatus = true
this.listPageNo += 1
this.getBusinessList()
},
selectBusiness (data) {
this.selectedBusiness.id = data._source.id
this.selectedBusiness.name = data._source.title
this.selectedBusiness.phone = data._source.phone
this.selectedBusiness.principalType = data._source.category
this.popupShow = false
},
onFileAdd (val) {
console.log(val,'ca;c;ac;a;c;ac');
this.fileList = this.fileList.concat(val)
},
onFileDel (index) {
this.fileList.splice(index, 1)
},
cityChange (index) {
this.curCityIndex = index
this.curCountyIndex = -1
},
countyChange (index) {
this.curCountyIndex = index

this.address = '海北藏族自治州海晏县'
this.palceCode = this.cityList[this.curCityIndex].county[this.curCountyIndex].code
this.cityPopupShow = false
this.selectedBusiness.name = ''
},
showCityPopup () {
this.cityPopupShow = true
},
closeCityPopup () {
this.cityPopupShow = false
},
submit () {
if (validate.check()) {
const postData = {
areaCode: '632223',//this.cityList[this.curCityIndex].county[this.curCountyIndex].code,
areaName: this.address,
fileIds: this.fileList,
principalName: this.$route.query.name!=='theComplaint'?'投诉对象':this.principalName,
principalPart: this.selectedBusiness.id,
principalTel: this.selectedBusiness.phone,
principalType: this.selectedBusiness.principalType,
reasons: this.$route.query.name!=='theComplaint'?'投诉内容':this.textValue,
userName: this.contactsName,
userPhone: this.contactsPhone,
deptCode: this.DEPT_CODE.DEPTCODE,
appCode: this.APP_CODE.APPCODE
}
const querystring = require('querystring')
this.$http.post('/api/wtcp-complaints/public/complaints?access_token=' + bus.userInfo.access_token, postData).then((response) => {
const that = this
if (response.data.status === 1) {
that.showToast('投诉成功，我们将尽快处理')
setTimeout(function () {
that.goCenter()
}, 2000)
} else {
that.showToast('投诉失败，请重试')
}
})
}
},
getLocation () {
mapUtil.locate((data) => {
this.locationResult(data)
}, (data) => {
this.locationResult(data)
})
},
locationResult (val) {
const adcode = val.addressComponent.adcode.substring(0, 6)
let flag = false
this.cityList.forEach((item1, idx1) => {
item1.county.forEach((item2, idx2) => {
if (item2.code == adcode) {
flag = true
this.curCityIndex = idx1
this.curCountyIndex = idx2

this.address = '海北藏族自治州海晏县'
}
})
})
if (!flag) {
this.showToast('不在事发地范围内')
}
},
onConfirm: function () {
this.$router.push({ path: '/login' })
},
goCenter: function () {
this.$router.push({ path: '/center' })
}
}
}
